// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerStyles } from "@synd/Overrides/Pages/Footer";
import { constants } from "@synd/XDL/constants";
import { xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

footerStyles.page = {
    fullWidth: [true, true, false, false, false],
    padding: 0,
    css: css`
        margin-top: ${constants.footer.offsetTop}px;
        ${xScreen("lte", "md")} {
            margin-top: ${constants.footer.offsetTopmd}px;
        }
    `,
};
